<template>
    <v-row class="hide-overflow flex-nowrap h-100" no-gutters>
        <v-col class="hide-overflow">
            <v-row class="pt-4 pb-3 pl-4 pr-4 b-b mb-0" dense>
                <v-col>
                    <v-select label="Status" :items="statuses" v-model="filters.status" outlined multiple clearable
                    hide-details dense :menu-props="{ offsetY: true }"></v-select>
                </v-col>
                <v-col>
                    <v-select label="Area" :items="areas" v-model="filters.area" outlined multiple clearable hide-details dense
                    :menu-props="{ offsetY: true }"></v-select>
                </v-col>
                <v-col>
                    <v-select label="Category" :items="categories" v-model="filters.category" outlined multiple clearable
                    hide-details dense :menu-props="{ offsetY: true }"></v-select>
                </v-col>
                <v-col>
                    <v-select label="Source" :items="sources" v-model="filters.source" outlined multiple clearable
                    hide-details dense :menu-props="{ offsetY: true }"></v-select>
                </v-col>
                <v-col>
                    <v-select label="Reason to hide" :items="reasonsToHide" v-model="filters.reasonToHide" outlined multiple clearable
                    hide-details dense :menu-props="{ offsetY: true }"></v-select>
                </v-col>
                <v-col>
                    <v-text-field label="ISCO Class" v-model="filters.escoClass" outlined clearable hide-details dense></v-text-field>
                </v-col>
                <v-col>
                    <v-text-field
                    label="Free-text search"
                    outlined
                    dense
                    v-model="filters.searchString"
                    placeholder="Title or company name"
                    clearable
                    hide-details
                    ></v-text-field>
                </v-col>
                <!-- <v-col>
                    TODO: NOT IMPLEMENTED
                    <v-btn outlined block color="primary" elevation="0" @click="importDialog = true">
                        Import jobs
                    </v-btn>
                </v-col> -->
                <v-col>
                <PositionNew @jobCreated="getJobs()" />
                <!-- <v-btn block color="primary" elevation="0" @click="createJob()">
                    <v-icon size="small">mdi-plus</v-icon>
                    Add job
                </v-btn> -->
                </v-col>
            </v-row>
            <v-row class="hide-overflow flex-nowrap" style="height:88%;" dense no-gutters>
                <v-col :cols="showEditor ? 8 : 12">
                    <div class="list-view">
                        <v-data-table
                            :loading="loading"
                            :headers="headers"
                            :items.sync="items"
                            :page.sync="page"
                            :items-per-page="itemsPerPage"
                            @page-count="pageCount = $event"
                            class="elevation-1"
                            show-select
                            hide-default-footer
                            @click:row="selectRow"
                            v-model="selectedRows"
                            item-key="key"
                        >
                            <template v-slot:[`item.actions`]="{ item }">
                                <!-- <v-icon small class="mr-2" @click="editRow(item)" disabled>
                                mdi-pencil
                                </v-icon> -->
                                <!-- <v-icon small color="error" @click="deleteRow(item)">
                                mdi-delete
                                </v-icon> -->
                                <v-btn icon :href="item.externalUrl" target="_blank">
                                    <v-icon color="primary" small>mdi-open-in-new</v-icon>
                                </v-btn>
                            </template>
                            <template v-slot:[`item.parsedStatus`]="{ item }">
                                <span v-for="status of Object.entries(item.parsedStatus).filter(e => e[1]).map(e => e[0]) "
                                    :key="status">
                                    <v-chip
                                        label
                                        small
                                        outlined
                                        class="mr-1"
                                        :color="getStatusColor(status)"
                                        v-if="status !== 'reviewed'">
                                        {{ status }}
                                    </v-chip>
                                </span>
                            </template>
                        </v-data-table>
                        <v-row class="pagination align-center">
                        <v-col class="ml-2">
                            <strong>Page {{ page }}</strong> of {{ pageCount }}
                        </v-col>
                        <v-col>
                            <v-pagination
                                v-model="page"
                                :length="pageCount"
                                total-visible="8">
                            </v-pagination>
                        </v-col>
                        </v-row>
                    </div>
                </v-col>
                <v-col class="b-l auto-overflow" v-if="showEditor">
                    <JobEditor :item="selectedJob" :action="editorAction" @saved="getJobs()" @close="showEditor = false" />
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>
<script>
import JobEditor from '@/components/JobEditor.vue';
import PositionNew from '@/components/PositionNew.vue';

export default {
  name: 'PositionListAdmin',
  components: {
    JobEditor,
    PositionNew,
  },
  data() {
    return {
      headers: [
        { text: 'Company', value: 'employer.name' },
        { text: 'Job title', value: 'title' },
        { text: 'City', value: 'location.city' },
        { text: 'Area', value: 'location.area' },
        { text: 'Status', value: 'parsedStatus' },
        { text: 'Actions', value: 'actions', sortable: false },
      ],
      statuses: [
        { text: 'Reviewed', value: 'reviewed' },
        { text: 'Unreviewed', value: 'unreviewed' },
        { text: 'Hidden', value: 'hidden' },
        { text: 'User submitted', value: 'userSubmitted' },
        { text: 'Reported', value: 'reported' },
        { text: 'Active', value: 'active' },
        { text: 'Expired', value: 'expired' },
      ],
      sources: [
        { text: 'Työmarkkinatori', value: 'tyomarkkinatori' },
        { text: 'Jobly', value: 'monster' },
        { text: 'The Hub', value: 'thehub' },
      ],
      startDateModal: false,
      endDateModal: false,
      filters: {
        status: [],
        area: [],
        category: [],
        source: [],
        reasonToHide: [],
        escoClass: '',
        searchString: '',
      },
      itemsPerPage: 8,
      page: 1,
      pageCount: 0,
      selectedJob: {},
      showEditor: false,
      editorAction: 'create',
      loading: false,
      selectedRows: [],
    };
  },
  async mounted() {
    await this.$store.dispatch('dispatchReasonsToHideAdmin');
  },
  methods: {
    selectRow(item) {
      this.showEditor = true;
      this.selectedJob = item;
      this.$store.dispatch('commitSelectedPosition', item);
    },
    getJobs() {
      this.loading = true;
      this.$store.dispatch('dispatchGetJobsAdmin')
        .then(() => {
          this.loading = false;
        });
    },
    getStatusColor(status) {
      switch (status) {
        case 'reviewed':
          return 'blue';
        case 'unreviewed':
          return 'orange';
        case 'hidden':
          return 'default';
        case 'userSubmitted':
          return 'info';
        case 'reported':
          return 'error';
        case 'active':
          return 'success';
        case 'expired':
          return 'error';
        default:
          return 'grey';
      }
    },
  },
  computed: {
    items() {
      let items = this.$store.state.searchResults;
      items = items.sort((a, b) => new Date(b.source.firstSeen).getTime() - new Date(a.source.firstSeen).getTime());
      items = items.map((item, i) => {
        const parsedStatus = {
          reviewed: item.status.reviewStatus !== 'unreviewed',
          unreviewed: item.status.reviewStatus === 'unreviewed',
          hidden: Object.keys(item.status.hiddenBecause).length > 0,
          userSubmitted: item.source.apiId.includes('jobsinfinland.fi'),
          reported: Object.keys(item.status.reportedBecause).length > 0,
          active:
            Object.keys(item.status.hiddenBecause).length === 0
            && new Date(item.schedule.expire).getTime() > Date.now(),
          expired: new Date(item.schedule.expire).getTime() < Date.now(),
        };
        const newItem = { ...item, parsedStatus, key: i };
        return newItem;
      }).filter((item) => {
        const itemFilterStates = [
          (this.filters.status && this.filters.status.length > 0)
            ? this.filters.status.some(status => item.parsedStatus[status]) : true,
          (this.filters.area && this.filters.area.length > 0)
            ? this.filters.area.includes(item.location.area) : true,
          (this.filters.category && this.filters.category.length > 0)
            ? item.clustering.categories.some(c => this.filters.category.includes(c.id)) : true,
          (this.filters.source && this.filters.source.length > 0)
            ? this.filters.source.some(s => item.source.apiId.includes(s)) : true,
          (this.filters.reasonToHide && this.filters.reasonToHide.length > 0)
            ? this.filters.reasonToHide.some(r => Object.keys(item.status.hiddenBecause).includes(r)) : true,
          (this.filters.escoClass && this.filters.escoClass.length > 0 && item.clustering.escoOccupations)
            ? item.clustering.escoOccupations.some(e => e.escoCode.startsWith(this.filters.escoClass)) : true,
          (this.filters.searchString && this.filters.searchString.length > 0)
            ? item.title.toLowerCase().includes(this.filters.searchString.toLowerCase())
            || item.employer.name.toLowerCase().includes(this.filters.searchString.toLowerCase()) : true,
        ];
        return itemFilterStates.every(f => f);
      });
      return items;
    },
    areas() {
      let areas = this.$store.state.mapData.map((area) => {
        return { text: area.name, value: area.name };
      });
      areas.push({ text: 'Unknown', value: 'Unknown' });
      return areas;
    },
    categories() {
      return this.$store.state.categoriesWithDetails.map((category) => {
        return { text: category.name, value: category.id };
      });
    },
    reasonsToHide() {
      return this.$store.state.reasonsToHideAdmin ? this.$store.state.reasonsToHideAdmin.map((reason) => {
        return { text: reason.description, value: reason.id };
      }).filter((reason) => {
        return reason.value !== 'deleted';
      }) : [];
    },
  },
};
</script>
<style>

</style>
